const getters = {
  token: state => state.user.token,
  access: state => state.user.access,
  name: state => state.user.name
}

export default getters
